export default __webpack_public_path__ + "static/banner2-6e8cd666f7f6d0e2c3c90babb66508bd.jpeg";